import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

function resolveNotificationOpenUrl(link) {
    if (!link || typeof window === "undefined") {
        return null;
    }
    const s = String(link).trim();
    if (s.startsWith("http://") || s.startsWith("https://")) {
        return s;
    }
    const path = s.startsWith("/") ? s : `/${s}`;
    return `${window.location.origin}${path}`;
}

async function showForegroundSystemNotification(payload) {
    const n = payload.notification || {};
    const data = payload.data || {};
    const title = String(n.title || data.title || "Kolay Doy").trim() || "Kolay Doy";
    const body = String(n.body || data.body || "").trim();
    const icon = n.icon || data.icon || undefined;

    if (!("Notification" in window)) {
        return;
    }
    if (Notification.permission !== "granted") {
        return;
    }

    const rawLink =
        payload.fcmOptions?.link ||
        data.link ||
        data.url ||
        payload.webpush?.fcm_options?.link;
    const openUrl = resolveNotificationOpenUrl(rawLink) || window.location.href;

    const options = {
        body,
        icon,
        data: { url: openUrl },
    };

    try {
        const swPath = `${process.env.PUBLIC_URL || ""}/firebase-messaging-sw.js`;
        const reg =
            (await navigator.serviceWorker.getRegistration(swPath)) ||
            (await navigator.serviceWorker.ready);
        if (reg) {
            await reg.showNotification(title, options);
        } else {
            new Notification(title, options);
        }
    } catch (e) {
        console.warn("Foreground notification display failed", e);
        try {
            new Notification(title, { body, icon });
        } catch (e2) {
            console.warn("new Notification fallback failed", e2);
        }
    }
}

// Your Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyCIsM3xWu1ws1ijXvAqfeDFUbDl0dkDhy8",
    authDomain: "kolaydoy-e551a.firebaseapp.com",
    projectId: "kolaydoy-e551a",
    storageBucket: "kolaydoy-e551a.firebasestorage.app",
    messagingSenderId: "919044739997",
    appId: "1:919044739997:web:c74aa30bc2ae5371281574"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize messaging only if the environment supports service workers
let messaging;
if ('serviceWorker' in navigator) {
    try {
        messaging = getMessaging(app);

        // Listen for incoming messages safely
        onMessage(messaging, (payload) => {
            console.log('📩 Firebase message received:', payload);
            if (typeof window !== "undefined") {
                window.dispatchEvent(
                    new CustomEvent("fcm-foreground-message", { detail: payload })
                );
            }
            void showForegroundSystemNotification(payload).catch((e) =>
                console.warn("showForegroundSystemNotification failed", e)
            );
        });
    } catch (err) {
        console.error('⚠️ Firebase Messaging initialization failed', err);
    }
} else {
    console.log('⚠️ Firebase Messaging not supported in this browser / WKWebView');
}

// Request user permission safely (ثبت SW قبل از getToken برای پایداری دیالوگ مجوز و توکن)
export const requestPermission = async () => {
    if (!messaging) {
        console.log('⚠️ Messaging not initialized. Cannot request permission.');
        return null;
    }

    try {
        const swUrl = `${process.env.PUBLIC_URL || ''}/firebase-messaging-sw.js`;
        const registration = await navigator.serviceWorker.register(swUrl);
        await navigator.serviceWorker.ready;

        const token = await getToken(messaging, {
            vapidKey: "BHcBl0eWcuydAezNbhB5NDuDufmjiTKsXwWlSJBZlEdltfxmHy7vClYVEmoRPfCt45egolfNwO_PzCYSrf1NvYc",
            serviceWorkerRegistration: registration,
        });
        return token;
    } catch (error) {
        console.error("Permission denied or failed to get token", error);
        return null;
    }
};

export { messaging };
